import { ContentType, Result } from '@standardnotes/domain-core';
export class GetAllContacts {
    constructor(items) {
        this.items = items;
    }
    execute() {
        return Result.ok(this.items.getItems(ContentType.TYPES.TrustedContact));
    }
}
